import { assert, error, log } from '../app/logger.js';
import { settings } from '../app/settings.js';
import { APIGoogleMaps } from './api/googlemaps/api_googlemaps.js';
import { APILeaflet } from './api/leaflet/api_leaflet.js';
import { LocMapMixin } from './locmap_mixin.js';

import './controls_bar.js';

const g_mapOptions = {
  center: { lat: 45.8371, lng: -78.3791 }, // Algonquin
  zoom: 8,
};

/**
 * Creates and initializes the map.
 */
class MapHandler {
  #LocMap;
  #mapPromise;
  #getMapPromise;
  #getMapPromiseResolve;

  constructor() {
    this.#getMapPromise = new Promise(
      resolve => (this.#getMapPromiseResolve = resolve)
    );
  }

  /**
   * Returns map when the map is created.
   */
  getMap() {
    return this.#getMapPromise;
  }

  /**
   * Appends the map to the given container element.
   */
  attachMapIfNot(mapContainerEl) {
    if (this.mapElement.parentNode != mapContainerEl) {
      mapContainerEl.appendChild(this.mapElement);
    }

    if (!this.#mapPromise) {
      this.#mapPromise = this.createMap();
    }
    return this.#mapPromise;
  }

  createMap() {
    const apis = {
      googlemaps: APIGoogleMaps,
      leaflet: APILeaflet,
    };
    const provider = settings.mapProvider;

    let api = apis[provider];
    if (!api) {
      error(`[load] unrecognized maps provider: ${provider}`);
      return Promise.resolve();
    }

    log(`[load] load ${provider} API`);
    for (let m in api) {
      if (m != 'Map') {
        window[m] = api[m];
      }
    }

    this.#LocMap = LocMapMixin(api.Map);
    return this.#LocMap
      .create(this.mapElement, g_mapOptions)
      .then(map => {
        assert(map, `[load] no map was created`);
        this.#getMapPromiseResolve(map);
        return map;
      })
      .catch(e => error(`[load] failed to load ${name} API`, e));
  }

  get mapElement() {
    if (!this.#mapElement) {
      this.#mapElement = document.createElement('div');
      this.#mapElement.setAttribute('id', 'map');
    }
    return this.#mapElement;
  }

  #mapElement;
}

const mapHandler = new MapHandler();

export { mapHandler };
